import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { INFO } from "@/lib/data";
import { LEGAL } from "@/lib/legal";

export default function Legal({ type }) {
  const doc = LEGAL[type];

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${doc.title} · Bar Ristorante Gabri`;
  }, [doc.title]);

  return (
    <div className="min-h-screen bg-bone">
      <header className="bg-charcoal text-bone">
        <div className="mx-auto max-w-[860px] px-5 sm:px-8 pt-10 pb-14">
          <Link to="/" className="inline-flex items-center gap-2 text-bone/70 hover:text-terracotta transition-colors text-sm font-sans mb-8">
            <ArrowLeft size={16} /> Torna alla home
          </Link>
          <div className="text-[10px] tracking-[0.34em] uppercase text-terracotta mb-3">Bar Ristorante Gabri · Cavi di Lavagna</div>
          <h1 className="font-serif font-light text-4xl sm:text-6xl leading-none">{doc.title}</h1>
          <p className="mt-4 text-bone/50 text-sm font-sans">Ultimo aggiornamento: {doc.updated}</p>
        </div>
      </header>

      <article className="mx-auto max-w-[860px] px-5 sm:px-8 py-16">
        {doc.sections.map((s, i) => (
          <section key={s.h || `sec-${i}`} className="mb-10">
            {s.h && <h2 className="font-serif text-2xl sm:text-3xl text-charcoal mb-3">{s.h}</h2>}
            {s.p.map((para, j) => (
              <p key={`${s.h || i}-${j}`} className="font-sans text-pebble leading-relaxed mb-3 text-[15px]">{para}</p>
            ))}
          </section>
        ))}

        <div className="mt-14 pt-8 border-t border-charcoal/10 font-sans text-sm text-pebble">
          <p><strong className="text-charcoal">Titolare del trattamento:</strong> {INFO.name}</p>
          <p>{INFO.street}, {INFO.cap} {INFO.city} ({INFO.province})</p>
          <p>Tel: {INFO.phoneDisplay} · Email: {INFO.email}</p>
        </div>

        <Link to="/" className="mt-10 inline-flex items-center gap-2 bg-terracotta hover:bg-terracotta-dark text-bone px-6 py-3 rounded-sm font-semibold transition-colors">
          <ArrowLeft size={16} /> Torna alla home
        </Link>
      </article>
    </div>
  );
}
